import VueCookies from "vue-cookies";
export default {
  methods: {
    handlerReqCreatItem(data, optionsItem) {
      let options =
        optionsItem.length > 0 && optionsItem[0].name === "" ? [] : optionsItem;

      let prices = [
        {
          amount: this.multiplicationThousand(
            this.checkNumReplaceComma(data.priceItem.exportPrice)
          ),
          priceTypeCode: "PRICE_EXPORT",
          currency: "VND",
          version: 0,
        },
        {
          amount: this.multiplicationThousand(
            this.checkNumReplaceComma(data.priceItem.importPrice)
          ),
          priceTypeCode: "PRICE_IMPORT",
          currency: "VND",
          version: 0,
        },
      ];

      let variationPrices =
        options.length > 0
          ? data.variations.map((e) => {
              return {
                price: [
                  {
                    amount: this.multiplicationThousand(
                      this.checkNumReplaceComma(e.prices.exportPrice)
                    ),
                    priceTypeCode: "PRICE_EXPORT",
                    currency: "VND",
                    version: 0,
                  },
                  {
                    amount: this.multiplicationThousand(
                      this.checkNumReplaceComma(e.prices.importPrice)
                    ),
                    priceTypeCode: "PRICE_IMPORT",
                    currency: "VND",
                    version: 0,
                  },
                ],
              };
            })
          : [];

      return {
        itemReq: {
          name: data.name.trim(),
          description: data.description,
          tags: data.tags,
          categoryId: data.categoryId,
          unit: {
            additionalUnits: [],
            name: data.unit.name != "" ? data.unit.name : "Cái",
          },
          options:
            options.length === 0
              ? []
              : options.map((e) => {
                  return {
                    name: e.name,
                    description: "",
                    values: e.values,
                  };
                }),
          images: data.images ? data.images : [''],
          warranty: data.warranty,
          variations:
            options.length === 0
              ? [
                  {
                    name: data.name.trim(),
                    sku: data.sku ? data.sku.trim() : "",
                    upc: data.upc ? data.upc.trim() : "",
                    images: data.images,
                    options: [],
                    prices: prices,
                    weightGram: data.weightInGram 
                      ? this.checkNumReplaceComma(data.weightInGram)
                      : 0,
                    weightInGram: data.weightInGram 
                      ? this.checkNumReplaceComma(data.weightInGram)
                      : 0,
                    unitMass: "gr",
                    lengthCentimeter: 0,
                    widthCentimeter: 0,
                    heightCentimeter: 0,
                    version: 0,
                    ordinal: 0,
                  },
                ]
              : data.variations.map((e) => {
                  return {
                    name: e.name.trim(),
                    images: e.images,
                    sku: e.sku ? e.sku.trim() : '',
                    upc: e.upc ? e.upc.trim() : '',
                    ordinal: 0,
                    weightGram: data.weightInGram 
                      ? this.checkNumReplaceComma(data.weightInGram)
                      : 0,
                    weightInGram: data.weightInGram 
                      ? this.checkNumReplaceComma(data.weightInGram)
                      : 0,
                    lengthInCentimeter: 0,
                    widthInCentimeter: 0,
                    heightInCentimeter: 0,
                    options: e.options.map((e) => {
                      return {
                        name: e.name,
                        description: "",
                        value: e.value,
                      };
                    }),
                  };
                }),
          appKey: "",
          appSubKey: "",
          locationToCreate: VueCookies.get("LID"),
          metaSearchable: {
            brand: data.metaSearchable.brand,
            isSelling: data.metaSearchable.isSelling,
            category: data.metaSearchable.category,
            useProductBatch: data.metaSearchable.statusBatch,
            useImeiAndSerial: (data.metaSearchable.statusImei)
              ? data.metaSearchable.statusImei
              : false,
          },
        },

        itemPriceReq: {
          price: prices,
          variationPrice:
            options.length === 0 ? [{ price: prices }] : variationPrices,
          currency: "VND",
          locationToCreate: VueCookies.get("LID"),
          onlyVisibleToCreatorApp: false,
          objectClass: "",
          objectName: "",
          appSubClass: "",
          appKey: "",
          appSubKey: "",
        },
      };
    },
  },
};
